import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCoqA0b9yuW_tzGoK064xAghx004RxCYuk",
    authDomain: "crm4-417a4.firebaseapp.com",
    projectId: "crm4-417a4",
    storageBucket: "crm4-417a4.firebasestorage.app",
    messagingSenderId: "935425933104",
    appId: "1:935425933104:web:69cc0a83b1481b9b9492f5",
    measurementId: "G-EFJ28XYKP0"
};

// Initialize Firebase safely
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, auth };
